var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5 2.56654C13.7092 2.56654 2.52956 13.7462 2.52956 27.537C2.52956 41.3278 13.7092 52.5074 27.5 52.5074C41.2908 52.5074 52.4704 41.3278 52.4704 27.537C52.4704 13.7462 41.2908 2.56654 27.5 2.56654ZM0.5 27.537C0.5 12.6253 12.5883 0.536987 27.5 0.536987C42.4117 0.536987 54.5 12.6253 54.5 27.537C54.5 42.4487 42.4117 54.537 27.5 54.537C12.5883 54.537 0.5 42.4487 0.5 27.537Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7812 37.8694C18.7812 39.0868 20.0984 39.8482 21.1533 39.2406L39.0928 28.9082C40.1497 28.2995 40.1497 26.7745 39.0928 26.1658L21.1533 15.8334C20.0984 15.2258 18.7812 15.9872 18.7812 17.2046V37.8694Z",
    fill: "white",
    fillOpacity: 0.7
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircle);
export default __webpack_public_path__ + "static/media/play-circle.0ac01e03.svg";
export { ForwardRef as ReactComponent };